<template>
  <div class="view view_page view-imprint">
    <div class="view_start__navbar navbar">
      <locale-chooser />
      <div class="navbar__logo"></div>
    </div>

    <div class="view-imprint__header">
      <a class="navbar__group" href="#" @click="goBack">
        <lucide-icon name="arrow-left" class="mr-2" />
        <span> {{ $t("labels.back") }}</span>
      </a>
      <div class="navbar__group">
        <button type="button" class="button-icon mr-2" @click="goBack">
          <lucide-icon name="x" />
        </button>
      </div>
    </div>

    <imprint-content class="view-imprint__content" />
  </div>
</template>

<script setup lang="ts">
import LucideIcon from "@core/ui/LucideIcon.vue";
import LocaleChooser from "@core/input/LocaleChooser.vue";
import ImprintContent from "@core/imprint/ImprintContent.vue";
import { useRouter } from "vue-router";

const router = useRouter();

function goBack() {
  router.back();
}
</script>

<style lang="scss">
.view-imprint {
  background-color: var(--color-background);

  &__content {
    padding: 3rem;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
  }
}
</style>
